import scrollLock from 'scroll-lock';
const {
  disablePageScroll,
  enablePageScroll,
  refillGaps,
  getPageScrollBarWidth,
} = scrollLock;

/**
 * Scroll lock integration
 * @description Fill gap for fixed elements: [data-scroll-lock-fill-gap]
 * @description Allow scroll for elements: [data-scroll-lock-scrollable]
 * @returns {{lock: function, unlock: function, fillGaps: function, getScrollBarWidth: function}} scroll lock methods object
 * @example
 * const scrollLock = useScrollLock();
 * scrollLock.lock();
 * @see https://github.com/FL3NKEY/scroll-lock
 */
export const useScrollLock = () => {
  let savedScrollY = 0;
  let touchTrapAdded = false;
  let lastY = 0;

  function getScrollable(el) {
    if (!el) return null;
    return el.closest('[data-scroll-lock-scrollable], .vfm__content');
  }

  function touchTrap(e) {
    const target = e.target;
    const scrollable = getScrollable(target);

    if (!scrollable) {
      e.preventDefault();
      return;
    }

    const currentY = e.touches[0] ? e.touches[0].clientY : 0;
    const goingDown = currentY < lastY;
    const atTop = scrollable.scrollTop <= 0;
    const atBottom =
      scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight;

    if ((atTop && !goingDown) || (atBottom && goingDown)) {
      e.preventDefault();
    }

    lastY = currentY;
  }

  function lockBodyScroll() {
    if (typeof window === 'undefined') return;

    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${savedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    document.documentElement.classList.add('modal-open');
    body.classList.add('modal-open');

    if (!touchTrapAdded) {
      lastY = savedScrollY;
      // window.addEventListener('touchmove', touchTrap, { passive: false });
      touchTrapAdded = true;
    }
  }

  function unlockBodyScroll() {
    if (typeof window === 'undefined') return;

    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';

    document.documentElement.classList.remove('modal-open');
    body.classList.remove('modal-open');

    if (touchTrapAdded) {
      // window.removeEventListener('touchmove', touchTrap);
      touchTrapAdded = false;
    }

    window.scrollTo(0, savedScrollY);
  }

  return {
    lock: disablePageScroll,
    unlock: enablePageScroll,
    lockBodyScroll,
    unlockBodyScroll,

    fillGaps: refillGaps,
    getScrollBarWidth: getPageScrollBarWidth,
  };
};
